<template>

    <el-container class="administer">
        <el-header>
            <p class="logo">北勘招聘后台管理系统</p>
        </el-header>
        <el-container>
            <el-aside width="200px" >
                <el-menu
                        default-active="2"
                        class="el-menu-vertical-demo"
                        @open="handleOpen"
                        @close="handleClose"
                        background-color="#545c64"
                        text-color="#fff"
                        active-text-color="#ffd04b">
                    <el-menu-item index="2">
                        <i class="el-icon-menu"></i>
                        <span slot="title">招聘发布</span>
                    </el-menu-item>
                    <el-menu-item index="3">
                        <i class="el-icon-document"></i>
                        <span slot="title">简历筛选</span>
                    </el-menu-item>
                </el-menu>

            </el-aside>
            <el-container>
                <el-main>



                </el-main>
                <!--<el-footer>Footer</el-footer>-->
                <!--<Footer/>-->
            </el-container>
        </el-container>
    </el-container>


</template>

<script>
    import Header from '../base/Header'
    import Footer from '../base/Footer'

    export default {
        name: 'Home',
        props: {},
        components: {Header,Footer},
        methods: {
            handleSelect(key, keyPath) {
            }
        },
        data() {
            return {
                search: '',
                activeIndex: '1',
            }
        },

    }
</script>

<style scoped lang="less">
    .el-header{
        background-color: #454d55;
        color: #333;
        text-align: center;
        line-height: 60px;
    }
    .el-footer{

    }

    .el-aside {
        background-color: #D3DCE6;
        color: #333;
        text-align: center;
        line-height: 200px;
    }

    .el-main {
        background-color: #E9EEF3;
        color: #333;
        text-align: center;
        line-height: 160px;
    }

    body > .el-container {
        margin-bottom: 40px;
    }

    .administer{
        min-height: 1000px;
        position: relative;

        .el-header{
            color: #FFF;
            font-size: 30px;
            text-align: left;
        }

        .el-aside {
            background-color: #545c64;
            color: #333;
            text-align: center;
            line-height: 200px;
            height: 1000px;
            .el-menu{
                height: 100%;
                background-color: #545c64;
            }
        }



    }
    /*.el-container:nth-child(5) .el-aside,*/
    /*.el-container:nth-child(6) .el-aside {*/
        /*line-height: 260px;*/
    /*}*/

    /*.el-container:nth-child(7) .el-aside {*/
        /*line-height: 320px;*/
    /*}*/

</style>
